/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tea_PackagesInputs */

const vi_nav_tea_packages = /** @type {(inputs: Nav_Tea_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng gói chè`)
};

/**

* @param {Nav_Tea_PackagesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_tea_packages = /** @type {((inputs?: Nav_Tea_PackagesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tea_PackagesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_tea_packages(inputs)
});